import EventPunsukDataRequest from './EventPunsukDataRequest'
import EventPunsukFamily from './EventPunsukFamily'
import EventPunsukAddress from './EventPunsukAddress'
import DashBoardEvenPunSuk from './DashBoardEvenPunSuk'

export default {
  EventPunsukDataRequest,
  EventPunsukFamily,
  EventPunsukAddress,
  DashBoardEvenPunSuk
}



// WEBPACK FOOTER //
// ./src/components/HRM/Event/index.js